// Dynamic playlist: whether upvalues sent while a song plays broadcast
// "@user is playing …" to the Radio thread (and credit the song in the
// station's next-track lottery). Public by default — the dock offers the
// opt-out.
const STORAGE_KEY = 'knovNowPlayingBroadcast'

export function nowPlayingBroadcastEnabled(): boolean {
    try {
        return window.localStorage.getItem(STORAGE_KEY) !== 'off'
    } catch {
        return true
    }
}

export function setNowPlayingBroadcastEnabled(enabled: boolean): void {
    try {
        if (enabled) {
            window.localStorage.removeItem(STORAGE_KEY)
        } else {
            window.localStorage.setItem(STORAGE_KEY, 'off')
        }
    } catch {
        // Storage unavailable: stay on the default (broadcasting).
    }
}
